/* eslint no-console: 0 */
export default function getFriendlyLanguage(string) {
  const { supportedLanguages } = this || {};
  const langs = { ...supportedLanguages };
  const langId = `${string}`.trim().toLowerCase();
  const { name = null } = langs[langId] || {};

  if (string && !name) console.warn('Language not found for [%s]', string);

  return name || 'Plain Text';
}
